import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _bulkCreateModifierGroupsRequest = { modifierGroups: '_modifierGroup' };
var _bulkCreateModifierGroupsResponse = {
    results: '_bulkCreateModifierGroupsResult',
};
var _bulkCreateModifierGroupsResult = { modifierGroup: '_modifierGroup' };
var _bulkDeleteModifierGroupsRequest = {};
var _bulkDeleteModifierGroupsResponse = {};
var _bulkUpdateModifierGroupsRequest = {
    modifierGroups: '_maskedModifierGroup',
};
var _bulkUpdateModifierGroupsResponse = {
    results: '_bulkUpdateModifierGroupsResult',
};
var _bulkUpdateModifierGroupsResult = { modifierGroup: '_modifierGroup' };
var _cloneModifierGroupsRequest = {};
var _cloneModifierGroupsResponse = {};
var _countModifierGroupsRequest = {};
var _countModifierGroupsResponse = {};
var _createModifierGroupRequest = { modifierGroup: '_modifierGroup' };
var _createModifierGroupResponse = { modifierGroup: '_modifierGroup' };
var _deleteModifierGroupRequest = {};
var _deleteModifierGroupResponse = {};
var _getModifierGroupRequest = {};
var _getModifierGroupResponse = { modifierGroup: '_modifierGroup' };
var _listModifierGroupRequest = {};
var _listModifierGroupResponse = { modifierGroups: '_modifierGroup' };
var _maskedModifierGroup = {
    mask: 'google.protobuf.FieldMask',
    modifierGroup: '_modifierGroup',
};
var _modifierGroup = {
    createdDate: 'google.protobuf.Timestamp',
    updatedDate: 'google.protobuf.Timestamp',
};
var _queryModifierGroupsRequest = {};
var _queryModifierGroupsResponse = { modifierGroups: '_modifierGroup' };
var _updateModifierGroupRequest = {
    mask: 'google.protobuf.FieldMask',
    modifierGroup: '_modifierGroup',
};
var _updateModifierGroupResponse = { modifierGroup: '_modifierGroup' };
function resolveWixRestaurantsMenusV1ModifierGroupsServiceUrl(opts) {
    var domainToMappings = {
        '*.dev.wix-code.com': [
            {
                srcPath: '/_api/restaurants-modifier-group',
                destPath: '',
            },
            {
                srcPath: '/restaurants/menus/v1/bulk/modifiers-groups/delete',
                destPath: '/v1/bulk/modifiers-groups/delete',
            },
            {
                srcPath: '/restaurants/menus/v1/bulk/modifiers-groups/update',
                destPath: '/v1/bulk/modifiers-groups/update',
            },
            {
                srcPath: '/restaurants/menus/v1/bulk/modifier-groups/create',
                destPath: '/v1/bulk/modifier-groups/create',
            },
            {
                srcPath: '/restaurants/menus/v1/modifier-groups',
                destPath: '/v1/modifier-groups',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/restaurants-modifier-group',
                destPath: '',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/_api/restaurants-modifier-group',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/restaurants-modifier-group',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/restaurants-modifier-group',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/restaurants-modifier-group',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/restaurants-modifier-group',
                destPath: '',
            },
            {
                srcPath: '/restaurants/menus/v1/bulk/modifiers-groups/delete',
                destPath: '/v1/bulk/modifiers-groups/delete',
            },
            {
                srcPath: '/restaurants/menus/v1/bulk/modifiers-groups/update',
                destPath: '/v1/bulk/modifiers-groups/update',
            },
            {
                srcPath: '/restaurants/menus/v1/bulk/modifier-groups/create',
                destPath: '/v1/bulk/modifier-groups/create',
            },
            {
                srcPath: '/restaurants/menus/v1/modifier-groups',
                destPath: '/v1/modifier-groups',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/restaurants-modifier-group',
                destPath: '',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/restaurants-modifier-group',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/restaurants/item-modifier-group',
                destPath: '',
            },
            {
                srcPath: '/restaurants/menus/v1/bulk/modifier-groups/create',
                destPath: '/v1/bulk/modifier-groups/create',
            },
            {
                srcPath: '/restaurants/menus/v1/bulk/modifiers-groups/delete',
                destPath: '/v1/bulk/modifiers-groups/delete',
            },
            {
                srcPath: '/restaurants/menus/v1/bulk/modifiers-groups/update',
                destPath: '/v1/bulk/modifiers-groups/update',
            },
            {
                srcPath: '/restaurants/menus/v1/modifier-groups',
                destPath: '/v1/modifier-groups',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/**
 * > **Note:** The Item Modifier Groups API only works with the Wix Restaurants Menus (New) app. Make sure you downloaded this app from [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
 *
 * Creates a modifier group.
 *
 * To create multiple modifier groups at once, use [Bulk Create Modifiers](https://dev.wix.com/docs/rest/business-solutions/restaurants/menus/item-modifier-groups/bulk-create-modifier-groups).
 */
export function createModifierGroup(payload) {
    var _a = serializer(_createModifierGroupRequest, { _modifierGroup: _modifierGroup }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createModifierGroupResponse, {
        _modifierGroup: _modifierGroup,
    }).fromJSON;
    function __createModifierGroup(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.menus.v1.item_modifier_group',
            method: 'POST',
            methodFqn: 'wix.restaurants.menus.v1.ModifierGroupsService.CreateModifierGroup',
            url: resolveWixRestaurantsMenusV1ModifierGroupsServiceUrl({
                protoPath: '/v1/modifier-groups',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createModifierGroup.fromReq = fromReq;
    __createModifierGroup.__isAmbassador = true;
    return __createModifierGroup;
}
/**
 * > **Note:** The Item Modifier Groups API only works with the Wix Restaurants Menus (New) app. Make sure you downloaded this app from [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
 *
 * Retrieves a modifier group by the ID.
 */
export function getModifierGroup(payload) {
    var _a = serializer(_getModifierGroupRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getModifierGroupResponse, {
        _modifierGroup: _modifierGroup,
    }).fromJSON;
    function __getModifierGroup(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.menus.v1.item_modifier_group',
            method: 'GET',
            methodFqn: 'wix.restaurants.menus.v1.ModifierGroupsService.GetModifierGroup',
            url: resolveWixRestaurantsMenusV1ModifierGroupsServiceUrl({
                protoPath: '/v1/modifier-groups/{modifierGroupId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getModifierGroup.fromReq = fromReq;
    __getModifierGroup.__isAmbassador = true;
    return __getModifierGroup;
}
/**
 * > **Note:** The Item Modifier Groups API only works with the Wix Restaurants Menus (New) app. Make sure you downloaded this app from [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
 *
 * Retrieves a list of up to 500 modifier groups.
 */
export function listModifierGroups(payload) {
    var _a = serializer(_listModifierGroupRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listModifierGroupResponse, {
        _modifierGroup: _modifierGroup,
    }).fromJSON;
    function __listModifierGroups(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.menus.v1.item_modifier_group',
            method: 'GET',
            methodFqn: 'wix.restaurants.menus.v1.ModifierGroupsService.ListModifierGroups',
            url: resolveWixRestaurantsMenusV1ModifierGroupsServiceUrl({
                protoPath: '/v1/modifier-groups',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listModifierGroups.fromReq = fromReq;
    __listModifierGroups.__isAmbassador = true;
    return __listModifierGroups;
}
/**
 * > **Note:** The Item Modifier Groups API only works with the Wix Restaurants Menus (New) app. Make sure you downloaded this app from [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
 *
 * Retrieves a list of modifier groups given the provided paging, filtering, and sorting. Up to 500 modifier groups can be returned per request.
 * For a detailed list of supported operations, see the [Supported Filters and Sorting](https://dev.wix.com/docs/rest/business-solutions/restaurants/menus/item-modifier-groups/supported-filters-and-sorting) article. To learn how to query modifier groups, see [API Query Language](https://dev.wix.com/docs/rest/articles/getting-started/api-query-language).
 */
export function queryModifierGroups(payload) {
    var _a = serializer(_queryModifierGroupsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_queryModifierGroupsResponse, {
        _modifierGroup: _modifierGroup,
    }).fromJSON;
    function __queryModifierGroups(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.menus.v1.item_modifier_group',
            method: 'POST',
            methodFqn: 'wix.restaurants.menus.v1.ModifierGroupsService.QueryModifierGroups',
            url: resolveWixRestaurantsMenusV1ModifierGroupsServiceUrl({
                protoPath: '/v1/modifier-groups/query',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __queryModifierGroups.fromReq = fromReq;
    __queryModifierGroups.__isAmbassador = true;
    return __queryModifierGroups;
}
/**
 * > **Note:** The Item API only works with the Wix Restaurants Menus (New) app. Make sure you have installed this app from the [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
 *
 * Retrieves the number of modifier groups that match a specified filter.
 *
 * If a filter isn't passed in the request, the endpoint returns the count of all modifier groups.
 */
export function countModifierGroups(payload) {
    var _a = serializer(_countModifierGroupsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_countModifierGroupsResponse, {}).fromJSON;
    function __countModifierGroups(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.menus.v1.item_modifier_group',
            method: 'POST',
            methodFqn: 'wix.restaurants.menus.v1.ModifierGroupsService.CountModifierGroups',
            url: resolveWixRestaurantsMenusV1ModifierGroupsServiceUrl({
                protoPath: '/v1/modifier-groups/count',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __countModifierGroups.fromReq = fromReq;
    __countModifierGroups.__isAmbassador = true;
    return __countModifierGroups;
}
/**
 * > **Note:** The Item Modifier Groups API only works with the Wix Restaurants Menus (New) app. Make sure you downloaded this app from [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
 *
 * Updates a modifier group.
 *
 * Each time a modifier group is updated, its revision increments by 1. The existing revision must be included when updating the modifier group. This ensures you're working with the latest modifier group information, and it prevents unintended overwrites.
 */
export function updateModifierGroup(payload) {
    var _a = serializer(_updateModifierGroupRequest, { _modifierGroup: _modifierGroup }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateModifierGroupResponse, {
        _modifierGroup: _modifierGroup,
    }).fromJSON;
    function __updateModifierGroup(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.menus.v1.item_modifier_group',
            method: 'PATCH',
            methodFqn: 'wix.restaurants.menus.v1.ModifierGroupsService.UpdateModifierGroup',
            url: resolveWixRestaurantsMenusV1ModifierGroupsServiceUrl({
                protoPath: '/v1/modifier-groups/{modifierGroup.id}',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateModifierGroup.fromReq = fromReq;
    __updateModifierGroup.__isAmbassador = true;
    return __updateModifierGroup;
}
/**
 * > **Note:** The Item Modifier Groups API only works with the Wix Restaurants Menus (New) app. Make sure you downloaded this app from [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
 *
 * Deletes a modifier group.
 */
export function deleteModifierGroup(payload) {
    var _a = serializer(_deleteModifierGroupRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_deleteModifierGroupResponse, {}).fromJSON;
    function __deleteModifierGroup(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.menus.v1.item_modifier_group',
            method: 'DELETE',
            methodFqn: 'wix.restaurants.menus.v1.ModifierGroupsService.DeleteModifierGroup',
            url: resolveWixRestaurantsMenusV1ModifierGroupsServiceUrl({
                protoPath: '/v1/modifier-groups/{modifierGroupId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __deleteModifierGroup.fromReq = fromReq;
    __deleteModifierGroup.__isAmbassador = true;
    return __deleteModifierGroup;
}
/**
 * > **Note:** The Item Modifier Groups API only works with the Wix Restaurants Menus (New) app. Make sure you downloaded this app from [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
 *
 * Creates multiple modifier groups.
 */
export function bulkCreateModifierGroups(payload) {
    var _a = serializer(_bulkCreateModifierGroupsRequest, { _modifierGroup: _modifierGroup }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkCreateModifierGroupsResponse, {
        _bulkCreateModifierGroupsResult: _bulkCreateModifierGroupsResult,
        _modifierGroup: _modifierGroup,
    }).fromJSON;
    function __bulkCreateModifierGroups(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.menus.v1.item_modifier_group',
            method: 'POST',
            methodFqn: 'wix.restaurants.menus.v1.ModifierGroupsService.BulkCreateModifierGroups',
            url: resolveWixRestaurantsMenusV1ModifierGroupsServiceUrl({
                protoPath: '/v1/bulk/modifier-groups/create',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkCreateModifierGroups.fromReq = fromReq;
    __bulkCreateModifierGroups.__isAmbassador = true;
    return __bulkCreateModifierGroups;
}
/**
 * > **Note:** The Item Modifier Groups API only works with the Wix Restaurants Menus (New) app. Make sure you downloaded this app from [Wix App Market](https://www.wix.com/app-market/wix-restaurants-menus-new).
 *
 * Updates multiple item modifier groups at once. This function supports partial updates.
 * Each time a modifier group is updated, its revision increments by 1. The existing revision must be included when updating an item modifier group. This ensures you're working with the latest item information, and prevents unintended overwrites.
 * Up to 100 modifier groups can be returned per request.
 */
export function bulkUpdateModifierGroups(payload) {
    var _a = serializer(_bulkUpdateModifierGroupsRequest, { _maskedModifierGroup: _maskedModifierGroup, _modifierGroup: _modifierGroup }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkUpdateModifierGroupsResponse, {
        _bulkUpdateModifierGroupsResult: _bulkUpdateModifierGroupsResult,
        _modifierGroup: _modifierGroup,
    }).fromJSON;
    function __bulkUpdateModifierGroups(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.menus.v1.item_modifier_group',
            method: 'POST',
            methodFqn: 'wix.restaurants.menus.v1.ModifierGroupsService.BulkUpdateModifierGroups',
            url: resolveWixRestaurantsMenusV1ModifierGroupsServiceUrl({
                protoPath: '/v1/bulk/modifiers-groups/update',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkUpdateModifierGroups.fromReq = fromReq;
    __bulkUpdateModifierGroups.__isAmbassador = true;
    return __bulkUpdateModifierGroups;
}
export function bulkDeleteModifierGroups(payload) {
    var _a = serializer(_bulkDeleteModifierGroupsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_bulkDeleteModifierGroupsResponse, {}).fromJSON;
    function __bulkDeleteModifierGroups(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.menus.v1.item_modifier_group',
            method: 'DELETE',
            methodFqn: 'wix.restaurants.menus.v1.ModifierGroupsService.BulkDeleteModifierGroups',
            url: resolveWixRestaurantsMenusV1ModifierGroupsServiceUrl({
                protoPath: '/v1/bulk/modifiers-groups/delete',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __bulkDeleteModifierGroups.fromReq = fromReq;
    __bulkDeleteModifierGroups.__isAmbassador = true;
    return __bulkDeleteModifierGroups;
}
/** Clone modifier groups from a different metasite. */
export function cloneModifierGroups(payload) {
    var _a = serializer(_cloneModifierGroupsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_cloneModifierGroupsResponse, {}).fromJSON;
    function __cloneModifierGroups(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.restaurants.menus.v1.item_modifier_group',
            method: 'POST',
            methodFqn: 'wix.restaurants.menus.v1.ModifierGroupsService.CloneModifierGroups',
            url: resolveWixRestaurantsMenusV1ModifierGroupsServiceUrl({
                protoPath: '/v1/ModifierGroups/clone',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __cloneModifierGroups.fromReq = fromReq;
    __cloneModifierGroups.__isAmbassador = true;
    return __cloneModifierGroups;
}
//# sourceMappingURL=http.impl.js.map